import { type BeneficiaryType } from './beneficiary';
import { type WorkingStatus } from 'individual/types/backgroundInfoForm';

export enum CoverageProduct {
  LIFE = 'LIFE',
  CRITICAL_ILLNESS = 'CRITICAL_ILLNESS',
  PERMANENT_DISABILITY = 'PERMANENT_DISABILITY',
  TEMPORARY_DISABILITY = 'TEMPORARY_DISABILITY',
}

export interface Coverage {
  coverageProduct: CoverageProduct;
  order: number;
  minGrantingAge: number;
  maxGrantingAge: number;
  minSumInsured: number;
  maxSumInsured: number;
  mandatory: boolean;
  selectableDeductibleDays: number[] | null;
  sumInsuredStep: number;
  minSumInsuredWhenOptionalCoverageSelected: number | null;
  preselectedDeductibleDays: number | null;
  preSelected: boolean | null;
  requiredWorkingStatus: WorkingStatus | null;
  promoElement: CoveragePromo | null;
}

export enum CoveragePromo {
  NEW = 'NEW',
  POPULAR = 'POPULAR',
}

enum TechnicalProduct {
  INDIVIDUAL_LIFE = 'INDIVIDUAL_LIFE',
}

export interface MarketableProduct {
  technicalProduct: TechnicalProduct;
  name: MarketableProductName;
  coverages: Coverage[];
  selectableInstallmentAmounts: number[];
  selectableBeneficiaryTypes: BeneficiaryType[];
  maxMonthlyIncome: number;
  maxDebt: number;
  maxChildren: number;
  productCode: string;
  documentTypes: string[];
}

export enum MarketableProductName {
  INDIVIDUAL_ALL = 'individual-all',
  INDIVIDUAL_LIFE = 'individual-life',
  INDIVIDUAL_CI = 'individual-ci',
  INDIVIDUAL_DISABILITY_ALL = 'individual-disability-all',
  INDIVIDUAL_TEMPORARY_DISABILITY = 'individual-temporary-disability',
  INDIVIDUAL_PERMANENT_DISABILITY = 'individual-permanent-disability',
}
